var document = require('./_global').document;
module.exports = document && document.documentElement;



//////////////////
// WEBPACK FOOTER
// D:/projects/feelway-pawnshop/pawnshop-web-client-feelway/node_modules/core-js/modules/_html.js
// module id = ../../../../core-js/modules/_html.js
// module chunks = polyfills